import type {
	GetOtaFirmwareReleasesQuery,
	GetOtaReleasesQuery,
	GetOtaRolloutsQuery
} from "~/gql/queries/ota.generated";

export const otaEndpoints = {
	AbortOtaRollout: {
		invalidatesTags: ["OtaRollouts"] as AddTagTypes
	},
	CreateOtaRelease: {
		invalidatesTags: ["OtaReleases"] as AddTagTypes
	},
	GetOtaFirmwareReleases: {
		transformResponse: (res: GetOtaFirmwareReleasesQuery) => res
	},
	GetOtaReleases: {
		providesTags: ["OtaReleases"] as AddTagTypes,
		transformResponse: (res: GetOtaReleasesQuery) => res
	},
	GetOtaRollouts: {
		providesTags: ["OtaRollouts"] as AddTagTypes,
		transformResponse: (res: GetOtaRolloutsQuery) => res
	},
	HaltOtaRelease: {
		invalidatesTags: ["OtaReleases", "OtaRollouts"] as AddTagTypes
	},
	PauseOtaRollout: {
		invalidatesTags: ["OtaRollouts"] as AddTagTypes
	},
	PromoteOtaRolloutRing: {
		invalidatesTags: ["OtaRollouts"] as AddTagTypes
	},
	PublishOtaRelease: {
		invalidatesTags: ["OtaReleases"] as AddTagTypes
	},
	ResumeOtaRollout: {
		invalidatesTags: ["OtaRollouts"] as AddTagTypes
	},
	StartOtaRollout: {
		invalidatesTags: ["OtaRollouts"] as AddTagTypes
	}
};
